import { Component, Inject } from "@angular/core"
import { CommonModule } from "@angular/common"
import { FormsModule } from "@angular/forms"
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog"
import { MatButtonModule } from "@angular/material/button"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatInputModule } from "@angular/material/input"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"
import { RECORDING_MESSAGE_MAX_CHARS } from "../../models/recording.model"
import { recordingApiError, RecordingService } from "../../services/recording.service"

export interface RecordingDeclineModalData {
  recordingName: string
  recordingId: number
  stationId: number
}

export interface RecordingDeclineModalResult {
  success: true
}

@Component({
  selector: "app-recording-decline-modal",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: "./recording-decline-modal.component.html",
  styleUrls: ["./recording-decline-modal.component.css"],
})
export class RecordingDeclineModalComponent {
  recordingName: string
  reason = ""
  submitError = ""
  sending = false
  readonly maxChars = RECORDING_MESSAGE_MAX_CHARS

  constructor(
    public dialogRef: MatDialogRef<RecordingDeclineModalComponent, RecordingDeclineModalResult | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: RecordingDeclineModalData,
    private recordingService: RecordingService,
  ) {
    this.recordingName = data?.recordingName ?? ""
  }

  get canSubmit(): boolean {
    const text = this.reason.trim()
    return text.length > 0 && text.length <= this.maxChars && !this.sending
  }

  submit(): void {
    const reason = this.reason.trim()
    if (!reason || this.sending) return
    if (reason.length > this.maxChars) {
      this.submitError = `Decline reason must be ${this.maxChars} characters or fewer`
      return
    }

    this.sending = true
    this.submitError = ""
    this.dialogRef.disableClose = true

    this.recordingService.decline(this.data.recordingId, this.data.stationId, reason).subscribe({
      next: () => {
        this.dialogRef.close({ success: true })
      },
      error: (err) => {
        this.sending = false
        this.dialogRef.disableClose = false
        this.submitError = recordingApiError(err, "Failed to decline recording. Please try again.")
      },
    })
  }
}
